import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.css';

export default class Modals {
    constructor(){
        this.fancyboxGallery = $('[data-fancybox="images"]');

        this.defaults();
        this.init();
    }

    init(){
        this.gallery();
    }

    defaults(){
        $.fancybox.defaults.hash = false;
        $.fancybox.defaults.arrows = false;
        $.fancybox.defaults.infobar = false;
        $.fancybox.defaults.touch = false;
        $.fancybox.defaults.toolbar = false;
        $.fancybox.defaults.smallBtn = true;
        // $.fancybox.defaults.caption = function() { return ''; };
        $.fancybox.defaults.btnTpl.smallBtn = '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}">Close X</button>';
        $.fancybox.defaults.btnTpl.arrowLeft = '<a data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" href="javascript:;"><span class="icon-slim-arrow-left"></span></a>';
        $.fancybox.defaults.btnTpl.arrowRight = '<a data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" href="javascript:;"><span class="icon-slim-arrow-right"></span></a>';
    }

    gallery() {
        this.fancyboxGallery.fancybox({
            arrows: true,
            baseTpl:
            `
            <div class="fancybox-container" role="dialog" tabindex="-1">
                <div class="fancybox-bg"></div>
                <div class="fancybox-inner">
                    <div class="fancybox-infobar">
                        <span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span>
                    </div>
                    <div class="fancybox-toolbar">{{buttons}}</div>
                    <div class="fancybox-navigation">{{arrows}}</div>
                    <div class="fancybox-stage-wrap"><div class="fancybox-stage"></div></div>
                    <div class="fancybox-caption"></div>
                </div>
            </div>
            `,
            thumbs: {
                autoStart: true,
                axis      : 'x',
                parentEl: ".fancybox-stage-wrap"
            },
            afterShow: (instance, slide) => {
                //Append title

              //  var $el = $('.programme_detail-view-page .fancybox-content');  //record the elem so you don't crawl the DOM everytime  
               // var bottom = $el.position().top + $el.outerHeight(true);
              //  var bottom2 = bottom - $el.height()
               // var bottom3  = bottom2 / 2;
              //  var bottom4 = bottom3 + 20;
                //$('.fancybox-thumbs').css({'bottom':bottom4, 'top':'auto'});
               // $('.fancybox-thumbs').css({'bottom':bottom4});
                $(window).resize(()=>{
               // var $el = $('.programme_detail-view-page .fancybox-content');  //record the elem so you don't crawl the DOM everytime  
               // var bottom = $el.position().top + $el.outerHeight(true);
              //  var bottom2 = bottom - $el.height()
               // var bottom3  = bottom2 / 2;
               // var bottom4 = bottom3 + 20;
              //  $('.fancybox-thumbs').css({'bottom':bottom4, 'top':'auto'});
              //  $('.fancybox-thumbs').css({'bottom':bottom4});
                });                
                
                if($('.fancybox-container .fancybox-slide--image.fancybox-slide--current .fancybox-content .fancybox-title').length === 0){
                    $('.fancybox-container .fancybox-slide--image.fancybox-slide--current .fancybox-content').prepend(`<div class="fancybox-title h1">${slide.opts.$orig[0].innerText}</div>`);
                }
            }
        });

    }
}

let x = document.querySelector("#login-modal #uPassword");
let y = document.querySelector('.login__colContainer #uPassword');
let z = document.querySelector('#uPasswordNew')
function passwordShowDash() {
    if (z.type === "password") {
        z.type = "text";
        $('span.eye').addClass('hideeye')
    } else {
        z.type = "password";
        $('span.eye').removeClass('hideeye')
    }

}
function passwordShow() {
    if (x.type === "password") {
        x.type = "text";
        $('span.eye').addClass('hideeye')
    } else {
        x.type = "password";
        $('span.eye').removeClass('hideeye')
    }

}
function passwordShowLogin() {
    if (y.type === "password") {
        y.type = "text";
        $('span.eye').addClass('hideeye')
    } else {
        y.type = "password";
        $('span.eye').removeClass('hideeye')
    }

}
$('.login__colContainer #uPassword').after('<span class="eye"></span>');
$('[for="uPasswordNew"]').after('<span class="eye"></span>');

$('.main-header__profileitem').on('click',function(){
    setTimeout(function(){
        $('#login-modal [for="uPassword"]').after('<span class="eye"></span>');
    },1000)
})
$(document).on('keyup','.login__colContainer #uPassword',function(){
    if(!$(this).val() == 0 ) {
        $('.eye').show();
    } else {
        $('.eye').hide();
    }
})
$(document).on('keyup','#login-modal #uPassword',function(){
    if(!$(this).val() == 0 ) {
        $('.eye').show();
    } else {
        $('.eye').hide();
    }
})
$(document).on('keyup','#uPasswordNew',function(){
    if(!$(this).val() == 0 ) {
        $('.eye').show();
    } else {
        $('.eye').hide();
    }
})
$(document).on('click','span.eye',function() {
    if($('#login-modal').length > 0) {
        passwordShow();
    }
    if($('.login__colContainer').length > 0) {
        passwordShowLogin() ();
    }
    if($('#uPasswordNew').length > 0) {
        passwordShowDash();
    }
})